// constants

// action_component_subject
const SET_BOOKING_LIST = "SET_BOOKING_LIST";
const RESET_BOOKING_LIST = "RESET_BOOKING_LIST";

// reducers

const initialState = [];

const Reducer = (state = initialState, action) => {
	switch (action.type) {
		case SET_BOOKING_LIST:
			return [...action.payload];

		case RESET_BOOKING_LIST:
			return [];

		default:
			return state;
	}
};

export default Reducer;

// actions

// const resolveAfter2Seconds = () => {
// 	return new Promise((resolve) => {
// 		setTimeout(() => {
// 			resolve("resolved");
// 		}, 2000);
// 	});
// };

// action_component_subject
// export const decrementTestCounter = () => async (dispatch) => {
// 	const result = await resolveAfter2Seconds();
// 	console.log(result);
// 	dispatch({
// 		type: INCREMENT_TEST_COUNTER,
// 	});
// };

// action_component_subject, prefix set(not update),empty(not remove),hide,show
export const setBookingList = (bookingList) => {
	return {
		type: SET_BOOKING_LIST,
		payload: bookingList,
	};
};

export const resetBookingList = () => {
	return {
		type: RESET_BOOKING_LIST,
	};
};
